import React, {useState, useEffect} from 'react';
import {
    Container,
    Typography,
    Grid,
    Box,
    CircularProgress,
    Alert,
} from '@mui/material';
import {createApiClient} from '../../services/ApiClient.jsx';
import StatsCards from "./StatsCard.jsx";
import CoursesSection from "./CourseSection.jsx";
import TeachingTips from "./TeachingTips.jsx";

const TeacherDashboard = ({accessToken, claims}) => {
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const apiClient = createApiClient(accessToken);

    // Username access
    const username = claims?.username || claims?.name || 'Teacher';
    console.log(claims)

    // Loading courses function
    const fetchCourses = async () => {
        try {
            const coursesResponse = await apiClient.get('/api/courses/taught');
            setCourses(coursesResponse.courses || []);
            setError(null);
        } catch (err) {
            console.error('Error fetching courses:', err);
            setError('Failed to load courses. Please try again later.');
        }
    };

    // Triggers data fetching on mount and when accessToken changes
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                await fetchCourses();
            } catch (err) {
                console.error('Error fetching dashboard data:', err);
                setError('Failed to load dashboard data. Please try again later.');
            } finally {
                setLoading(false);
            }
        };

        if (accessToken) {
            fetchData();
        }
    }, [accessToken]);


    const handleCourseCreated = async (newCourse) => {
        // Refreshing courses after creating a new one to fetch the new ids
        await fetchCourses();
    };

    return (
        <Container maxWidth="xl" sx={{mt: 8, pb: 10}}>
            {/* Welcome header */}
            <Box sx={{mb: 4}}>
                <Typography variant="h4" gutterBottom>
                    Welcome, {username}!
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    Manage your courses, create content, and analyze student performance.
                </Typography>
            </Box>

            {/* Error alert */}
            {error && (
                <Alert severity="error" sx={{mb: 4}}>
                    {error}
                </Alert>
            )}

            {/* Loading indicator */}
            {loading && (
                <Box sx={{display: 'flex', justifyContent: 'center', my: 4}}>
                    <CircularProgress/>
                </Box>
            )}

            {!loading && (
                <Grid container spacing={4}>
                    {/* Top stats */}
                    <Grid size={12}>
                        <StatsCards courses={courses}/>
                    </Grid>

                    {/* Left column */}
                    <Grid size={{xs: 12, md: 8}}>
                        <CoursesSection
                            courses={courses}
                            onCourseCreated={handleCourseCreated}
                            apiClient={apiClient}
                        />
                    </Grid>

                    {/* Right column */}
                    <Grid size={{xs: 12, md: 4}}>
                        <TeachingTips/>
                    </Grid>
                </Grid>
            )}
        </Container>
    );
};

export default TeacherDashboard;